
<!-- eslint-disable -->
<template>
  <div class="p2s2m1_condition_entry">
      
    <div v-if="conditionIndex > 0"  class="p2s2m1_condition_operator_container">
      <hr>
      <select class="p2s2m1c1_match_condition" @change="updateValues" v-model="editOperator">
          <option value="or" >Or Match Condition {{conditionIndex +1}}</option>
          <option value="and" >And Match Condition {{conditionIndex +1}}</option>
      </select>
    </div>
    <label class="p2s2m1_condition_label">Condition {{conditionIndex +1}}</label>
    <span class="p2s2m1_condition_description_container">
        <input class="p2s2m1_condition_description_field p2s2m1_input_field" @change="updateValues" type="text" v-model="editDescription" placeholder="Description (optional)">
    </span>

    <div class="p2s2m1_condition_entry_remove_condition_button_container">
        <button 
        v-if="conditionIndex > 0"
        class="p2s2m1_condition_entry_remove_condition_button" 
        @click="removeSelf"
        ></button>
    </div>
    <div class="p2s2m1_sub_conditions_container">
      <p2s2m1c2-sub-condition-entry
        v-for="(sub_condition,sub_condition_index) in conditionEntry.sub_conditions"
        :key="sub_condition_index"
        :comparisonOperator="sub_condition.operator"
        :comparisonValue="sub_condition.value"
        :andLabelFlag="sub_condition_index > 0"
        :conditionIndex="conditionIndex"
        :subConditionIndex="sub_condition_index"
        :lastSubConditionFlag="sub_condition_index === (conditionEntry.sub_conditions.length -1)"
        @event-add-sub-condition="passEventAddSubConditon"
        @event-remove-sub-condition="passEventRemoveSubConditon"
        @event-sub-condition-changed="passEventSubConditonChanged"
      ></p2s2m1c2-sub-condition-entry>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import p2s2m1c2SubConditionEntry from "./p2s2m1c2SubConditionEntry";
export default {
  name: "p2s2m1c1ConditionEntry",
  props: ["conditionIndex", "conditionEntry"],
  components: {
    p2s2m1c2SubConditionEntry,
  },
  data: function() {
    return {
      editDescription: null,
      editOperator: null,
      removeConditonFlag: false,
    };
  },
  mounted: function() {
    this.editDescription = this.conditionEntry.description;
    this.editOperator = this.conditionEntry.operator;
  },

  methods: {
    updateValues: function(event) {
      this.$emit("event-condition-changed", [this.conditionIndex, [this.editOperator, this.editDescription]]);
    },
    removeSelf: function() {
      this.removeConditonFlag = true;
      this.$emit("event-remove-condition", this.conditionIndex);
    },
    passEventAddSubConditon(msg) {
      if (this.removeConditonFlag === true) {
        return;
      }
      this.$emit("pass-event-add-sub-condition", msg);
    },
    passEventRemoveSubConditon(msg) {
      if (this.removeConditonFlag === true) {
        return;
      }
      this.$emit("pass-event-remove-sub-condition", msg);
    },
    passEventSubConditonChanged(msg) {
      if (this.removeConditonFlag === true) {
        return;
      }
      this.$emit("pass-event-sub-condition-changed", msg);
    },
  },

  watch: {
    conditionEntry: {
      handler: function() {
        this.editDescription = this.conditionEntry.description;
        this.editOperator = this.conditionEntry.operator;
      },
      deep: true,
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/p2Dashboard/p2s2notifications/p2s2m1/p2s2m1c1ConditionEntry.vue